export default {
  CHATGPT_API_KEY: 'CHATGPT_API_KEY',
  CHATGPT_MODEL: 'CHATGPT_MODEL',
  CHATGPT_PROMPT: 'CHATGPT_PROMPT',
  CHATGPT_TEMPERATURE: 'CHATGPT_TEMPERATURE',
  CHATGPT_MAX_TOKENS: 'CHATGPT_MAX_TOKENS',
  CHATGPT_REASONING_EFFORT: 'CHATGPT_REASONING_EFFORT',
  CHATGPT_FILE_SEND_MODE: 'CHATGPT_FILE_SEND_MODE',
  CHATGPT_TOOLS: 'CHATGPT_TOOLS',
  CHATGPT_INCLUDE: 'CHATGPT_INCLUDE',
  CHATGPT_RESPOND_AS_BOTIUM_JSON: 'CHATGPT_RESPOND_AS_BOTIUM_JSON'
}
